import { toggleAriaExpanded, toggleExpanded } from '../_utilities/aria'
import { pushDataLayer } from '../_utilities/data-layer'

const submenus = document.querySelectorAll<HTMLElement>('[data-nav-trigger]')
const mobileNav = document.getElementById('mobile-nav')
const mobileNavTrigger = document.getElementById('mobile-nav-trigger')
const mobileNavClose = document.getElementById('mobile-nav-close')
const mobileSearchTrigger = document.getElementById('mobile-search-trigger')
const overlay = document.getElementById('overlay')
const toggleContentAware = (e: Event) => {
    if (window.innerWidth >= 1280) {
        if (
            !mobileNav?.contains(e.target as Node) &&
            !document.getElementById('nav-desktop')?.contains(e.target as Node)
        ) {
            if (document.documentElement.classList.contains('nav--active')) {
                document.documentElement.classList.remove('nav--active')
            }
        } else {
            if (!document.documentElement.classList.contains('nav--active')) {
                document.documentElement.classList.add('nav--active')
            }
        }
    }
}

const showNavDesktop = (e: Event) => {
    if (window.innerWidth >= 1280) {
        document.documentElement.classList.add('nav--active')
    }
}

const disableNavAndRemoveFocus = (e: Event) => {
    if (window.innerWidth >= 1280) {
        document.documentElement.classList.remove('nav--active');
        (document.activeElement as HTMLElement).blur()
    }
}

submenus.forEach((nav) => {
    nav.addEventListener('mouseenter', showNavDesktop)
    nav.addEventListener('focusin', toggleContentAware)
    nav.addEventListener('mouseleave', disableNavAndRemoveFocus)
    nav.addEventListener('focusout', disableNavAndRemoveFocus)
})

if (overlay) {
    overlay.addEventListener('click', () => {
        const wasMobileNavOpen = mobileNav?.dataset.expanded === 'true'
        document.documentElement.classList.remove('nav--active')
        if (wasMobileNavOpen) {
            toggleExpanded(mobileNav!, 'false')
            mobileNavTrigger?.setAttribute('aria-expanded', 'false')
            mobileSearchTrigger?.setAttribute('aria-expanded', 'false')
            pushDataLayer({ event: 'close_menu' })
        }
    })
}

mobileNavTrigger?.addEventListener('click', () => {
    document.documentElement.classList.add('nav--active')
    pushDataLayer({ event: 'open_menu' })
})

mobileSearchTrigger?.addEventListener('click', () => {
    document.documentElement.classList.add('nav--active')
    document.getElementById('mobile-nav-search-input')?.focus()
})

mobileNavClose?.addEventListener('click', () => {
    if (mobileNav) toggleExpanded(mobileNav, 'false')
    document.documentElement.classList.remove('nav--active')
    mobileNavTrigger?.setAttribute('aria-expanded', 'false')
    mobileSearchTrigger?.setAttribute('aria-expanded', 'false')
    pushDataLayer({ event: 'close_menu' })
})

const closeAllMobileNavs = () => {
    mobileNav?.querySelectorAll('[aria-expanded="true"]').forEach((nav) => {
        toggleAriaExpanded(nav as HTMLElement)
    })
}

window.closeAllMobileNavs = closeAllMobileNavs
